import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c77d9b1&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4c77d9b1&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77d9b1",
  null
  
)

export default component.exports